/**
 * Haptic feedback.
 *
 * Wraps @capacitor/haptics so callers never have to think about the platform.
 * On web every call is a no-op, so these are safe to sprinkle anywhere.
 *
 * Pick by meaning, not by strength:
 *   tap()     - a normal button, a tab, opening a sheet
 *   select()  - moving through options: filters, grades, variants, toggles
 *   success() - something completed: card added, trade requested, saved
 *   warn()    - a soft refusal or a limit reached
 *   error()   - something failed
 */

import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

const native = () => Capacitor.isNativePlatform();

// Haptics reject on some devices/settings; feedback is never worth an exception.
const quiet = (p) => { try { p?.catch?.(() => {}); } catch { /* no-op */ } };

export const tap = () => { if (native()) quiet(Haptics.impact({ style: ImpactStyle.Light })); };
export const select = () => { if (native()) quiet(Haptics.selectionChanged()); };
export const heavy = () => { if (native()) quiet(Haptics.impact({ style: ImpactStyle.Medium })); };
export const success = () => { if (native()) quiet(Haptics.notification({ type: NotificationType.Success })); };
export const warn = () => { if (native()) quiet(Haptics.notification({ type: NotificationType.Warning })); };
export const error = () => { if (native()) quiet(Haptics.notification({ type: NotificationType.Error })); };

const haptics = { tap, select, heavy, success, warn, error };
export default haptics;
